export const themModeSelector = (state) => state.auth.themMode;
export const userInfoSelector = (state) => state.auth.userInfo;
